<template>
    <div>
        <b-modal id="full-img-modal"
                 ref="full-img-modal"
                 :hide-footer="true"
                 :hide-header="true"
                 content-class="bg-map contain-bg p-0 border-0"
                 size="xl"
                 @hidden="hidden"
        >
            <div class="float-right text-bold">
                <img :src="require('../assets/img/cancel.svg')" alt="" height="20" class="pointer"
                     @click="hideZoomModal()">
            </div>
            <slot name="content"></slot>
        </b-modal>
    </div>
</template>

<script>
  import { EventBus } from '../eventBus'

  export default {
    props: {
    },
    data () {
      return {}
    },
    methods: {
      hidden () {
        EventBus.$emit('zoomHidden')
      }
    }
  }
</script>

<style lang="scss" scoped>
    .bg-map {
        height: auto;
    }

    /*.map-img {*/
        /*object-fit: contain;*/
        /*width: 100%;*/
        /*display: block;*/
        /*margin: auto;*/
        /*height: 646px;*/
    /*}*/
</style>